const Footer = () => (
  <footer className="bg-[#060E1A] border-t border-white/5 pt-16 pb-8">
    <div className="max-w-7xl mx-auto px-6 md:px-10">
      <div className="grid grid-cols-1 md:grid-cols-4 gap-10 mb-12">
        {/* Brand */}
        <div className="md:col-span-1">
          <div className="flex items-center gap-3 mb-4">
            <img
              src="https://static.readdy.ai/image/09b42268e64b75a1bdbfb319cdd0d3b1/944ced67edcaa1780fffee96bcaa68e9.png"
              alt="CyberSkill Hub"
              className="h-8 w-auto object-contain"
            />
            <span className="text-white font-bold text-base">
              Cyber<span className="text-[#00D9FF]">Skill</span>
            </span>
          </div>
          <p className="text-gray-500 text-sm leading-relaxed mb-5">
            The premier platform for cybersecurity learners to practice, grow, and connect with a global community of security professionals.
          </p>
          <div className="flex items-center gap-3">
            {['ri-twitter-x-line', 'ri-discord-line', 'ri-github-line', 'ri-linkedin-box-line'].map((icon) => (
              <a
                key={icon}
                href="#"
                className="w-8 h-8 rounded-lg bg-white/5 flex items-center justify-center text-gray-500 hover:text-[#00D9FF] hover:bg-[#00D9FF]/10 transition-all duration-200 cursor-pointer"
              >
                <i className={`${icon} text-sm`}></i>
              </a>
            ))}
          </div>
        </div>

        {/* Links */}
        {[
          {
            title: 'Platform',
            links: ['Labs', 'Resources', 'CTF Challenges', 'Learning Paths', 'Certifications'],
          },
          {
            title: 'Community',
            links: ['Forum', 'Discord', 'Leaderboard', 'Write-ups', 'Events'],
          },
          {
            title: 'Company',
            links: ['About Us', 'Careers', 'Blog', 'Press Kit', 'Contact'],
          },
        ].map((col) => (
          <div key={col.title}>
            <h4 className="text-white font-bold text-xs uppercase tracking-widest mb-4">{col.title}</h4>
            <ul className="space-y-3">
              {col.links.map((link) => (
                <li key={link}>
                  <a
                    href="#"
                    className="text-gray-500 text-sm hover:text-[#00D9FF] transition-colors duration-200 cursor-pointer"
                  >
                    {link}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/5 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
        <p className="text-gray-600 text-xs">
          &copy; 2026 CyberSkill Hub. All rights reserved.
        </p>
        <div className="flex items-center gap-6">
          {['Privacy Policy', 'Terms of Service', 'Cookie Policy'].map((item) => (
            <a
              key={item}
              href="#"
              className="text-gray-600 text-xs hover:text-gray-400 transition-colors duration-200 cursor-pointer whitespace-nowrap"
            >
              {item}
            </a>
          ))}
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;
